<template>
  <section>
    <LoadingSpinner v-if="loading" />
  <div v-else  class="row">
    <div class="col-md-1"></div>
    <div class="col-md-10 card py-4">
      <div class="row">
        <div class="col-md-12">
          <div class="container text-center mb-4">
            <h4>{{ $t("lang.preparingapp.title") }}</h4>
            <span>{{ $t("lang.preparingapp.subtitle") }}</span> <!--titulo-->
          </div>
        </div>
      </div>

      <div class="row mt-3" v-if="isBilling"> <!-- Make your first order-->
        <div class="col-md-1"></div>
        <div class="col-md-10">
          <div class="container card w100 p-4">
            <div class="row">
              <div class="col-md-12">
                <div class="float-left">
                  <small v-if="!doneYourFirstOrder.yourFirstOrder"
                    class="rounded-circle icon-checkmark bg-white border-secondary border text-white"></small>
                  <small v-else><small class="p-1 rounded-circle icon-checkmark bg-primary text-white"></small></small>
                </div>
                <div class="ml-4 mt-1 col-12 p-0">
                  <div class="row mb-2">
                    <div class="col-6 col-md-5 my-0 py-0">
                      <h6 class="mr-5 p-0">{{ $t("lang.preparingapp.prepare") }}</h6>
                    </div>
                    <div class="col-6 col-md-7 m-0 p-0 d-flex d-inline justify-content-end">
                      <vue-form-generator
                      :schema="schemaMakeYourFirstOrder" 
                      :model="doneYourFirstOrder"
                      @model-updated="handleFirstOrder" />
                    </div>
                  </div>
                  <div class="col-12 pl-0 pr-3">
                    <small class="text-secondary my-0">{{ $t("lang.preparingapp.prepare_desc") }}</small>
                  </div>
                  <button 
                  :disabled="doneYourFirstOrder.yourFirstOrder"
                  @click="$router.push('/orders')" class="btn btn-md btn-outline-primary mt-2">
                    {{ $t("lang.preparingapp.prepare_btn") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-1"></div>
      </div>

      <div class="row mt-3"> <!-- Define your team-->
        <div class="col-md-1"></div>
        <div class="col-md-10">
          <div class="container card w100 p-4">
            <div class="row">
              <div class="col-md-12">
                <div class="float-left">
                  <small v-if="!doneSyncMyCalendar.syncMyCalendar"
                    class="rounded-circle icon-checkmark bg-white border-secondary border text-white"></small>
                  <small v-else><small class="p-1 rounded-circle icon-checkmark bg-primary text-white"></small></small>
                </div>
                <div class="ml-4 mt-1 col-12 p-0">
                  <div class="row mb-2">
                    <div class="col-6 col-md-5 my-0 py-0">
                      <h6>{{ $t("lang.preparingapp.defineyourteam") }}</h6>
                    </div>
                    <div class="col-6 col-md-7 m-0 p-0 d-flex d-inline justify-content-end">
                      <vue-form-generator 
                      :schema="schemaSyncMyCalendar" 
                      :model="doneSyncMyCalendar"
                        @model-updated="handleSyncMyCalendar" />
                    </div>
                  </div>
                  <div class="col-12 pl-0 pr-3">
                    <small class="text-secondary my-0">{{ $t("lang.preparingapp.defineyourteam_desc") }}</small>
                  </div>
                  <button 
                  :disabled="doneSyncMyCalendar.syncMyCalendar"
                  @click="$router.push('/calendar_config')" 
                  class="btn btn-md btn-outline-primary mt-2" >
                    {{ $t("lang.button.syncmyemail") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-1"></div>
      </div>

      <div class="row mt-3" v-if="isBilling"> <!-- Black list-->
        <div class="col-md-1"></div>
        <div class="col-md-10">
          <div class="container card w100 p-4">
            <div class="row">
              <div class="col-md-12">
                <div class="float-left">
                  <small v-if="!words && !doneBlacklist.requireBlacklist"
                    class="rounded-circle icon-checkmark bg-white border-secondary border text-white"></small>
                  <small v-else><small class="p-1 rounded-circle icon-checkmark bg-primary text-white"></small></small>
                </div>
                <div class="ml-4 mt-1 col-12 p-0">
                  <div class="row mb-2">
                    <div class="col-6 col-md-5 my-0 py-0">
                      <h6 class="mr-5 p-0"> {{ $t("lang.preparingapp.uploaddomain") }} </h6>
                    </div>
                    <div class="col-6 col-md-7 m-0 p-0 d-flex d-inline justify-content-end" >
                      <vue-form-generator 
                      :schema="schemaSkipBlacklist" 
                      :model="doneBlacklist"
                      @model-updated="handleBlacklist()" />
                    </div>
                  </div>
                  <div class="col-12 pl-0 pr-3">
                    <small class="text-secondary my-0">{{ $t("lang.preparingapp.uploaddomain_desc") }}</small>
                  </div>
                  <button 
                    :disabled="doneBlacklist.requireBlacklist"
                    @click="$router.push('/settings-account?blacklist=1')" 
                    class="btn btn-md btn-outline-primary mt-2">
                    {{ $t("lang.preparingapp.uploaddomain_btn") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-1"></div>
      </div>

      <div class="row mt-3"> <!-- Logo -->
        <div class="col-md-1"></div>
        <div class="col-md-10">
          <div class="container card w100 p-4">
            <div class="row">
              <div class="col-md-12">
                <div class="float-left">
                  <small v-if="!doneMyLogo.upMyLogo"
                    class="rounded-circle icon-checkmark bg-white border-secondary border text-white"></small>
                  <small v-else><small class="p-1 rounded-circle icon-checkmark bg-primary text-white"></small></small>
                </div>
                <div class="ml-4 mt-1 col-12 p-0">
                  <div class="row mb-2">
                    <div class="col-6 col-md-5 my-0 py-0">
                      <h6 class="mr-4">{{ $t("lang.preparingapp.complete_profile") }}</h6>
                    </div>
                    <div class="col-6 col-md-7 m-0 p-0 d-flex d-inline justify-content-end">
                      <vue-form-generator 
                        :schema="schemaUpMyLogo" 
                        :model="doneMyLogo"
                        @model-updated="handleSchemaUpMyLogo" />
                    </div>
                  </div>
                  <div class="col-12 pl-0 pr-3">
                    <small class="text-secondary">
                      {{ $t("lang.preparingapp.define_complete_profile") }}
                    </small>
                  </div>
                  <button 
                  :disabled="doneMyLogo.upMyLogo"
                  @click="$router.push('/settings-account')" 
                  class="btn btn-md btn-outline-primary mt-2">
                    {{ $t("lang.preparingapp.complete_profile") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-1"></div>
      </div>
    </div>
    <div class="col-md-1"></div>
  </div>
</section>
</template>

<script>
import ClientTeam from "@/components/Account/ClientTeam.vue";
import { clientsService, usersService } from "@/_services";
import { mapActions } from "vuex";
import LoadingSpinner from "@/components/LoadingSpinner.vue";



export default {
  props: {
    user: { type: Object }
  },
  data() {
    return {
      doneBlacklist: {
        requireBlacklist: false,
      },
      doneYourFirstOrder: {
        yourFirstOrder: false,
      },
      doneSyncMyCalendar: {
        syncMyCalendar: false,
      },
      doneMyLogo: {
        upMyLogo: false,
      },
      words: false,
      optionSelected: false,
      savingData: false,
      hasBlacklist: false,
      schemaSkipBlacklist: {
        fields: [
          {
            type: "switch",
            model: "requireBlacklist",
            featured: true,
            id: "requireBlacklist",
            textOn: "Done",
            textOff: "To do",
            valueOn: true,
            valueOff: false,
            styleClasses: "col-md-12 my-0",
          }
        ]
      },
      schemaMakeYourFirstOrder: {
        fields: [
          {
            type: "switch",
            model: "yourFirstOrder",
            featured: true,
            id: "yourFirstOrder",
            textOn: "Done",
            textOff: "To do",
            valueOn: true,
            valueOff: false,
            styleClasses: "col-md-12 my-0",
          }
        ]
      },
      schemaSyncMyCalendar: {
        fields: [
          {
            type: "switch",
            model: "syncMyCalendar",
            featured: true,
            id: "syncMyCalendar",
            textOn: "Done",
            textOff: "To do",
            valueOn: true,
            valueOff: false,
            styleClasses: "col-md-12 my-0",
          }
        ]
      },
      schemaUpMyLogo: {
        fields: [
          {
            type: "switch",
            model: "upMyLogo",
            featured: true,
            id: "upMyLogo",
            textOn: "Done",
            textOff: "To do",
            valueOn: true,
            valueOff: false,
            styleClasses: "col-md-12 my-0",
          }
        ]
      },
      switches: {},
      loading: true,
    };
  },
  components: {
    ClientTeam,
    LoadingSpinner

  },
  computed: {
    isBilling() {
      const isBilling = this.user.role_id == 4 ? true : false;
      return isBilling;
    },
    isBillingSaleOrSales() {
      const isBillingSaleOrSales =
        (this.user.role_id == 4 && this.user.sales_representative_id != null) ||
        this.user.role_id == 3
          ? true
          : false;
      return isBillingSaleOrSales;
    },
    isSales() {
      return this.user.role_id == 3 ? true : false;
    },
  },
  created() {

    this.$store.dispatch("authentication/refreshToken").then((result) => {

      this.switches =  (this.user.switches ) ? JSON.parse(this.user.switches) : {};

      this.getFirstOrder();
      this.getSyncCalendar();
      this.getMyLogo();
      this.getBlacklist();
      this.loading = false;

    });


  },
  methods:{
    ...mapActions("onboarding", {
      setStatusOnboarding: "setStatusOnboarding",
    }),

    //Update status RequireBlackList (0, 1) in client
    async getBlacklist() {
      try {
        //this.switches = JSON.parse(this.user.switches);

        const item = {
          name: 'blacklist',
          value: this.switches.blacklist
        };
        this.doneBlacklist.requireBlacklist =  item.value; // para acomodar el switch en on / off

        this.setStatusOnboarding(item);
      } catch (error) {
        console.log(error);
      }
    },

    async handleBlacklist() {

      try {
        const item = {
          name: 'blacklist',
          value: (this.doneBlacklist.requireBlacklist) ? true : false
        };
        this.switches.blacklist = item.value;
        const res = await usersService.setSwitches(this.switches);
        this.setStatusOnboarding(item);


      } catch (error) {
        console.log(error);
      }
    },

    async getFirstOrder() {
      try {

        //this.switches = JSON.parse(this.user.switches);

         const item = {
           name: 'firstOrder',
           value: this.switches.order
         };
         this.doneYourFirstOrder.yourFirstOrder = item.value;
        this.setStatusOnboarding(item);
      } catch (error) {
        console.log(error);
      }
    },

    async handleFirstOrder() {
      try {
        const item = {
          name: 'firstOrder',
          value: (this.doneYourFirstOrder.yourFirstOrder) ? true : false
        };
        this.switches.order = item.value;
        const res = await usersService.setSwitches(this.switches);
        this.setStatusOnboarding(item);

      } catch (error) {
        console.log(error);
      }

    },

    async getSyncCalendar() {
      try {

       // this.switches = JSON.parse(this.user.switches);

         const item = {
           name: 'emailSincronized',
           value: this.switches.calendar
         };
         this.doneSyncMyCalendar.syncMyCalendar= item.value;
        this.setStatusOnboarding(item);
      } catch (error) {
        console.log(error);
      }
    },

    async handleSyncMyCalendar() {
      try {
        const item = {
          name: 'emailSincronized',
          value: (this.doneSyncMyCalendar.syncMyCalendar) ? true : false
        };
        this.switches.calendar = item.value;
        const res = await usersService.setSwitches(this.switches);
        this.setStatusOnboarding(item);

      } catch (error) {
        console.log(error);
      }

    },

    async getMyLogo() {
      try {
        //this.switches = JSON.parse(this.user.switches);

         const item = {
           name: 'avatar',
           value: this.switches.logo
         };
         this.doneMyLogo.upMyLogo = item.value;
        this.setStatusOnboarding(item);
      } catch (error) {
        console.log(error);
      }
    },

    async handleSchemaUpMyLogo() {
      try {

        const item = {
          name: 'avatar',
          value: (this.doneMyLogo.upMyLogo) ? true : false
        };
        this.switches.logo = item.value;
        const res = await usersService.setSwitches(this.switches);
        this.setStatusOnboarding(item);

      } catch (error) {
        console.log(error);
      }

    },

  }
};
</script>
